var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.18196C6 4.44559 6.59695 3.84863 7.33333 3.84863H8.66667C9.40305 3.84863 10 4.44559 10 5.18197V12.5153C10 12.8835 9.70152 13.182 9.33333 13.182H6.66667C6.29848 13.182 6 12.8835 6 12.5153V5.18196Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 9.18229C11.3335 8.8141 11.632 8.51562 12.0002 8.51562H13.3335C14.0699 8.51562 14.6668 9.11258 14.6668 9.84896V12.5156C14.6668 12.8838 14.3684 13.1823 14.0002 13.1823H12.0002C11.632 13.1823 11.3335 12.8838 11.3335 12.5156V9.18229Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8.51595C1.3335 7.77957 1.93045 7.18262 2.66683 7.18262H4.00016C4.36835 7.18262 4.66683 7.48109 4.66683 7.84928V12.516C4.66683 12.8841 4.36835 13.1826 4.00016 13.1826H2.00016C1.63197 13.1826 1.3335 12.8841 1.3335 12.516V8.51595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIc);
export default __webpack_public_path__ + "static/media/leaderboard_ic.0015399039cb092071f668943ab06407.svg";
export { ForwardRef as ReactComponent };